// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .pw-lightbox-poster[data-v-31002de7]{width:100%!important;height:auto!important}#aw--c #aw-sl .pw-lightbox-poster img[data-v-31002de7]{visibility:hidden!important}", ""]);
// Exports
module.exports = exports;
